module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "workOrderManage"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "15px",
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "searthPart",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('ul', {
    staticClass: "order-status"
  }, [_c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(2)
      }
    }
  }, [_c('span', [_vm._v("待处理")]), _vm._v(" "), (_vm.orderNot.count2 > 0) ? _c('span', [_vm._v(_vm._s(_vm.orderNot.count2))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 5
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(5)
      }
    }
  }, [_c('span', [_vm._v("已挂起")]), _vm._v(" "), (_vm.orderNot.count5 > 0) ? _c('span', [_vm._v(_vm._s(_vm.orderNot.count5))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 4
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(4)
      }
    }
  }, [_c('span', [_vm._v("无法确认")]), _vm._v(" "), (_vm.orderNot.count4 > 0) ? _c('span', [_vm._v(_vm._s(_vm.orderNot.count4))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 11
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(11)
      }
    }
  }, [_c('span', [_vm._v("已完成")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 7
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(7)
      }
    }
  }, [_c('span', [_vm._v("待派单")]), _vm._v(" "), (_vm.orderNot.count7 > 0) ? _c('span', [_vm._v(_vm._s(_vm.orderNot.count7))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 8
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(8)
      }
    }
  }, [_c('span', [_vm._v("已派单")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    class: {
      highLight: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        return _vm.clickLi(1)
      }
    }
  }, [_c('span', [_vm._v("全部订单")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix orderListsLi",
    staticStyle: {
      "border": "none"
    }
  }, [(_vm.basicsAuth.createOrder) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createOrder()
      }
    }
  }, [_vm._v("新建工单")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form', {
    ref: "searchForm",
    staticClass: "form-wrapper",
    attrs: {
      "model": _vm.searchForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "工单编号"
    },
    model: {
      value: (_vm.searchForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.orderNo"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "客户名称"
    },
    model: {
      value: (_vm.searchForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.customerName"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "客户手机号"
    },
    model: {
      value: (_vm.searchForm.telephoneNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "telephoneNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.telephoneNo"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "客户地址"
    },
    model: {
      value: (_vm.searchForm.address),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.address"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "城市"
    },
    model: {
      value: (_vm.searchForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "cityName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.cityName"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "245px",
      "margin-bottom": "10px"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "daterange",
      "range-separator": "-",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "下单开始",
      "end-placeholder": "下单结束"
    },
    model: {
      value: (_vm.valueTime1),
      callback: function($$v) {
        _vm.valueTime1 = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "valueTime1"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "245px",
      "margin-bottom": "10px"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "daterange",
      "range-separator": "-",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "预约开始",
      "end-placeholder": "预约结束"
    },
    model: {
      value: (_vm.valueTime2),
      callback: function($$v) {
        _vm.valueTime2 = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "valueTime2"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "110px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "处理人"
    },
    on: {
      "change": function($event) {
        return _vm.change()
      }
    },
    model: {
      value: (_vm.searchForm.handleRmk),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "handleRmk", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.handleRmk"
    }
  }, _vm._l((_vm.handleList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.staffName,
        "value": item.userId
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "110px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "filter-method": _vm.PinyinMatch,
      "placeholder": "工程师"
    },
    on: {
      "change": _vm.changeEnginner
    },
    model: {
      value: (_vm.searchForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "engineerId", $$v)
      },
      expression: "searchForm.engineerId"
    }
  }, _vm._l((_vm.engineersList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.searchForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "brandId", $$v)
      },
      expression: "searchForm.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1), _vm._v(" "), (_vm.categoryList.length > 0) ? _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.searchForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v)
      },
      expression: "searchForm.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.modelList.length > 0) ? _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.searchForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "modelId", $$v)
      },
      expression: "searchForm.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('el-input', {
    staticClass: "text-input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入故障"
    },
    model: {
      value: (_vm.searchForm.faultSubclassName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "faultSubclassName", $$v)
      },
      expression: "searchForm.faultSubclassName"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "订单类型"
    },
    model: {
      value: (_vm.searchForm.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "serviceType", $$v)
      },
      expression: "searchForm.serviceType"
    }
  }, _vm._l((_vm.orderTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "订单状态"
    },
    model: {
      value: (_vm.searchForm.adminStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "adminStatus", $$v)
      },
      expression: "searchForm.adminStatus"
    }
  }, _vm._l((_vm.orderStatusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "245px",
      "margin-bottom": "10px"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "daterange",
      "range-separator": "-",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "完成开始",
      "end-placeholder": "完成结束"
    },
    model: {
      value: (_vm.valueTime3),
      callback: function($$v) {
        _vm.valueTime3 = $$v
      },
      expression: "valueTime3"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "125px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "渠道"
    },
    model: {
      value: (_vm.searchForm.orderIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderIdentifier", $$v)
      },
      expression: "searchForm.orderIdentifier"
    }
  }, _vm._l((_vm.OrderNolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "110px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "处理状态"
    },
    model: {
      value: (_vm.searchForm.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "handleStatus", $$v)
      },
      expression: "searchForm.handleStatus"
    }
  }, _vm._l((_vm.handleStatusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "search-button-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("检索工单")]), _vm._v(" "), (_vm.basicsAuth.exportData) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.clearFrom
    }
  }, [_vm._v("重置")])], 1)], 1)])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    key: "tableCard",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "id": "tableId",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "row-dblclick": _vm.toDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isTag == 1) ? _c('i', {
          staticClass: "el-icon-star-on",
          staticStyle: {
            "color": "#f4ea2a"
          },
          on: {
            "click": function($event) {
              return _vm.kefuaddOrderMessage(scope.row)
            }
          }
        }) : _c('i', {
          staticClass: "el-icon-star-off",
          on: {
            "click": function($event) {
              return _vm.setOrderTagOpe(scope.row, 1)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "sortable": "",
      "label": "工单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("sysCodeFileter")(scope.row.adminStatus, 'admin_status')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "label": "工单编号",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.orderNo))])]
      }
    }])
  }), _vm._v(" "), (_vm.activeIndex === 4) ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "align": "center",
      "width": "200",
      "prop": "cannotConfirmDesc",
      "label": "无法确认原因"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "160",
      "sortable": "",
      "prop": "createTime",
      "label": "下单时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "prop": "customerName",
      "label": "客户信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.customerName))]), _vm._v(" "), _c('i', {
          staticClass: "iconfont hohofast-copy copyBtn",
          on: {
            "click": function($event) {
              return _vm.handleCopyCustomer(scope.row, $event)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "120",
      "sortable": "",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "colorName",
      "width": "80",
      "sortable": "",
      "label": "颜色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "140",
      "sortable": "",
      "label": "故障"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return (item != null && item.faultSubclassShortName != null) ? _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassShortName) + ",")]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "190",
      "sortable": "",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteDate) + " " + _vm._s(scope.row.onsiteTimeStart) + "~" + _vm._s(scope.row.onsiteTimeEnd) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "countyAddress",
      "sortable": "",
      "width": "110",
      "label": "区域"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "prop": "address",
      "width": "330",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderIdentifier",
      "width": "120",
      "sortable": "",
      "label": "渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.orderIdentifier, 'order_identifier')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "sortable": "",
      "prop": "serviceType",
      "label": "工单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("sysCodeFileter")(scope.row.serviceType, 'order_type')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "staffName",
      "width": "100",
      "sortable": "",
      "label": "受理人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "handleName",
      "width": "100",
      "sortable": "",
      "label": "处理人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "handleDate",
      "width": "160",
      "sortable": "",
      "label": "处理时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.handleDate) ? _c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row.handleDate)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "sortable": "",
      "prop": "cancelReason",
      "label": "取消原因"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.cancelReason, 'order_cancel_reason')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "prop": "cancelDesc",
      "label": "原因描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "150",
      "sortable": "",
      "prop": "maintenanceResult",
      "label": "维修结果"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.maintenanceResult, 'maintenance_result')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "actualPrice",
      "width": "120",
      "sortable": "",
      "label": "实收金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "60",
      "label": "履历"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.checkHitoryRecord(scope.row.id)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), (_vm.activeIndex === 9) ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "align": "center",
      "width": "190",
      "fixed": "right",
      "label": "送机方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "wayId",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-select', {
          attrs: {
            "filterable": "",
            "placeholder": "送机方式"
          },
          model: {
            value: (scope.row.sendMachineWay),
            callback: function($$v) {
              _vm.$set(scope.row, "sendMachineWay", $$v)
            },
            expression: "scope.row.sendMachineWay"
          }
        }, _vm._l((_vm.sendWaylList), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.paraName,
              "value": item.paraValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [(_vm.basicsAuth.sendWays) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.confirmSendWay(scope.row)
            }
          }
        }, [_vm._v("确认")]) : _vm._e()], 1)], 1)]
      }
    }], null, false, 3074908559)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "prop": "telephoneNo",
      "label": "客户电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "prop": "amountPayable",
      "label": "维修估价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.amountPayable) ? _c('span', [_vm._v(_vm._s(Number(scope.row.amountPayable).toFixed(2)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "prop": "cityName",
      "label": "所在市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "sortable": "",
      "label": "工程师"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.serviceType == 'QS' || scope.row.serviceType == 'QD') && scope.row.isFetch != 2) ? _c('span', [_vm._v(_vm._s(scope.row.fetchName))]) : (scope.row.sendMachineWay == 3) ? _c('span', [_vm._v(_vm._s(scope.row.sendName))]) : _c('span', [_vm._v(_vm._s(scope.row.engineerName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "sortable": "",
      "prop": "paymentId",
      "label": "支付方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.paymentId) ? _c('span', [_vm._v(_vm._s(_vm._f("sysCodeFileter")(scope.row.paymentId, 'pay_way')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "500",
      "prop": "handleRemark",
      "label": "客服备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "500",
      "prop": "memo",
      "label": "工程师备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "prop": "repairFailureReason",
      "label": "失败原因"
    }
  }), _vm._v(" "), (_vm.activeIndex === 2 || _vm.activeIndex === 5 || _vm.activeIndex === 4 || _vm.activeIndex === 9) ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "align": "center",
      "fixed": "right",
      "width": "50",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (_vm.activeIndex === 2 || _vm.activeIndex === 5 || _vm.activeIndex === 4 || _vm.activeIndex === 9) ? [(_vm.basicsAuth.reassignmentOrder) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.reassignmentOrder(scope.row)
            }
          }
        }, [_vm._v("改派")]) : _vm._e()] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单修改记录",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.historyList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.orderNo",
      "label": "服务单号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.createTime",
      "label": "下单时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.customerName",
      "label": "客户姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.updateTime",
      "label": "修改时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.updateUserName",
      "label": "修改人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.orderType",
      "label": "工单类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.adminStatus",
      "label": "状态",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.orderIdentifier",
      "label": "渠道来源",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("sysCodeFileter")(scope.row.oldOrderInfo.orderIdentifier, 'order_identifier')) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.telephoneNo",
      "label": "手机号码",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.provinceName",
      "label": "所在省",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.cityName",
      "label": "所在市",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.countyName",
      "label": "所在区",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "prop": "oldOrderInfo.address",
      "label": "详细地址",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.onsiteDate",
      "label": "预约日期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "预约时间",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.oldOrderInfo.onsiteTimeStart) + " ~ " + _vm._s(scope.row.oldOrderInfo.onsiteTimeEnd) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.brandName",
      "label": "品牌",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.categoryName",
      "label": "品类",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.modelName",
      "label": "型号",
      "sortable": "",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.colorName",
      "label": "颜色",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.faultSubclassNames",
      "label": "问题代码",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "oldOrderInfo.price",
      "label": "维修估价(元)",
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建改派",
      "visible": _vm.dialogFormVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm
    }
  }, [_c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "orderNo", $$v)
      },
      expression: "modelForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在城市",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "cityName", $$v)
      },
      expression: "modelForm.cityName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在区域",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.countyName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "countyName", $$v)
      },
      expression: "modelForm.countyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.address),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "address", $$v)
      },
      expression: "modelForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "预约时间",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.onsiteDate + ' ' + _vm.modelForm.onsiteTimeStart + '~' + _vm.modelForm.onsiteTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.modelForm.onsiteDate + ' ' + _vm.modelForm.onsiteTimeStart + '~' + _vm.modelForm, "onsiteTimeEnd", $$v)
      },
      expression: "modelForm.onsiteDate +' '+ modelForm.onsiteTimeStart +'~'+modelForm.onsiteTimeEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelName", $$v)
      },
      expression: "modelForm.modelName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "颜色",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorName", $$v)
      },
      expression: "modelForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.faultSubclassStr),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "faultSubclassStr", $$v)
      },
      expression: "modelForm.faultSubclassStr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "已派客服",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.staffName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "staffName", $$v)
      },
      expression: "modelForm.staffName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "改派客服",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.PinyinMatch1,
      "placeholder": "请选择客服"
    },
    on: {
      "change": _vm.changeCustomer
    },
    model: {
      value: (_vm.modelForm.applyRmk),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "applyRmk", $$v)
      },
      expression: "modelForm.applyRmk"
    }
  }, _vm._l((_vm.customerServicesList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.staffName,
        "value": item.customerServicesId
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('modelForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createReassign
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加备注",
      "visible": _vm.dialogmessageForm,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogmessageForm = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm
    }
  }, [_c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "orderNo", $$v)
      },
      expression: "modelForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在城市",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "cityName", $$v)
      },
      expression: "modelForm.cityName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在区域",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.countyName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "countyName", $$v)
      },
      expression: "modelForm.countyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.address),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "address", $$v)
      },
      expression: "modelForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "预约时间",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.onsiteDate + ' ' + _vm.modelForm.onsiteTimeStart + '~' + _vm.modelForm.onsiteTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.modelForm.onsiteDate + ' ' + _vm.modelForm.onsiteTimeStart + '~' + _vm.modelForm, "onsiteTimeEnd", $$v)
      },
      expression: "modelForm.onsiteDate +' '+ modelForm.onsiteTimeStart +'~'+modelForm.onsiteTimeEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelName", $$v)
      },
      expression: "modelForm.modelName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "颜色",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorName", $$v)
      },
      expression: "modelForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障详情",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.faultSubclassStr),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "faultSubclassStr", $$v)
      },
      expression: "modelForm.faultSubclassStr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('el-form-item', {
    attrs: {
      "label": "工单回复",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.message),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "message", $$v)
      },
      expression: "modelForm.message"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createMessage
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "支付",
      "width": "400px",
      "visible": _vm.dialogModelFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogModelFormVisible = $event
      },
      "close": _vm.emptyPayDialog
    }
  }, [_c('el-form', {
    ref: "modelPayForm",
    attrs: {
      "rules": _vm.modelFormRules,
      "model": _vm.modelPayForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付方式",
      "prop": "paymentId",
      "clearable": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择支付方式"
    },
    model: {
      value: (_vm.modelPayForm.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.modelPayForm, "paymentId", $$v)
      },
      expression: "modelPayForm.paymentId"
    }
  }, _vm._l((_vm.payWaylList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付金额",
      "prop": "actualPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入实收金额",
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelPayForm.actualPrice),
      callback: function($$v) {
        _vm.$set(_vm.modelPayForm, "actualPrice", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelPayForm.actualPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.emptyPayDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveModelFormSubmitBtn('modelPayForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 30
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 500, 1000, 2000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-0c413121","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/workOrderManage.vue
// module id = 1581
// module chunks = 0